export default {
  setOrgId(state, payload) {
    state.orgId = payload;
  },
  setOrgs(state, payload) {
    state.data = payload;
  },
  setInviteCode(state, { orgId, code }) {
    state.inviteCodes = { ...state.inviteCodes, [orgId]: code };
  },
  ADD_ORG(state, payload) {
    state.data.push(payload);
  },
  CLEAR(state) {
    state.data = [];
    state.inviteCodes = {};
    state.orgId = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/orgs/mutations.js